import React, { useContext } from 'react';

import styled from '@emotion/styled';

import { TableFilterBoxProps } from '../Table';
import { TableContext } from '../TableContext';
import TableFilterBox from './TableFilterBox';
import TableSearchBox from './TableSearchBox';

const TableFilterAndSearchBox: React.FC<TableFilterBoxProps> = ({
  searchBoxPlaceholder,
  rightAttr,
  leftAttr,
  showSearchBox,
  filterBoxBottomBorder,
}) => {
  const tableContext = useContext(TableContext);

  return (
    <Container filterBoxBottomBorder={filterBoxBottomBorder}>
      <Boundary>
        {showSearchBox && (
          <TableSearchBox
            setSearchQuery={(value) =>
              tableContext?.handleSetTableFilterRecord({
                search: value,
                page: 0,
              })
            }
            placeholder={searchBoxPlaceholder}
          />
        )}

        {leftAttr &&
          leftAttr.length > 0 &&
          leftAttr.map((attr, index) => {
            return attr.type === 'filter' ? (
              <TableFilterBox
                key={`left-${index}-${attr.type}`}
                filterControlForm={attr.comp}
              />
            ) : (
              <React.Fragment key={`left-${index}-${attr.type}`}>
                {attr.comp}
              </React.Fragment>
            );
          })}
      </Boundary>

      <Boundary>
        {rightAttr &&
          rightAttr.length > 0 &&
          rightAttr.map((attr, index) => {
            return attr.type === 'filter' ? (
              <TableFilterBox
                key={`right-${index}-${attr.type}`}
                filterControlForm={attr.comp}
              />
            ) : attr.type === 'custom-filter' ? (
              attr.comp
            ) : (
              <React.Fragment key={`right-${index}-${attr.type}`}>
                {attr.comp}
              </React.Fragment>
            );
          })}
      </Boundary>
    </Container>
  );
};

export default TableFilterAndSearchBox;

interface ContainerProps {
  filterBoxBottomBorder?: boolean;
}

const Container = styled.div<ContainerProps>`
  display: flex;
  margin-left: auto;
  width: fit-content;
  gap: 8px;

  border-bottom: ${({ filterBoxBottomBorder, theme }) =>
    filterBoxBottomBorder ? `1px solid ${theme.palette.borderColor}` : 'none'};
  padding-bottom: ${({ filterBoxBottomBorder }) =>
    filterBoxBottomBorder ? '22px' : '0'};
`;

const Boundary = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: fit-content;

  &.small-gap {
    gap: 12px;
  }

  &.mobile {
    display: none;
  }

  @media (max-width: 884px) {
    display: none;
    &.mobile {
      width: 100%;
      display: grid;
      /* grid-template-columns: repeat(4, auto); */
      grid-template-columns: 1fr auto 1fr 1fr;
    }
  }
`;
